module.exports = __webpack_public_path__ + "img/question.1b7d57a0.png";